import React from 'react'
import PropTypes from 'prop-types'
import Cookies from 'js-cookie'
import R from 'ramda'
import { cn } from '../components/helpers'
import TumblBackground from '../components/TumblrBackground'
import Main from '../components/Main'

/**
 * Genevieve
 */

const sizes = ['hd', 'large', 'medium', 'small']
const videoCount = 3
const videoRoot = 'https://luckyme-public.s3.amazonaws.com/littlebabyangel/genevieve-video/'
const videoPrefix = 'gen_'
const suffixes = ['mp4', 'webm', 'jpg']

const videos = R.reduce(
  ((acc, size) => (
    R.assoc(size,
      R.times(number => (
        R.map(suffix => `${videoRoot}${videoPrefix}${number + 1}-${size}.${suffix}`)(suffixes)
      ))(videoCount)
      , acc,
    )
  )),
  {},
)(sizes)

class Genevieve extends React.Component {
  constructor(props) {
    super(props)
    this.setVideoSources = this.setVideoSources.bind(this)
    this.playVideo = this.playVideo.bind(this)
    this.watchScroll = this.watchScroll.bind(this)
    this.onVideoPlay = this.onVideoPlay.bind(this)
    this.registerVideoRef = this.registerVideoRef.bind(this)

    this.state = {
      playing: false,

    }
  }

  isMobile = () => {
    if (window.innerWidth >= 1024) {
      this.setState({
        isMobile: false
      })
    } else if (window.innerWidth <= 480) {
      this.setState({
        isMobile: true
      })
    }
  }

  openPageUrlMobile = (url) => {
    window.open(url, "_blank")
  }


  componentDidMount() {
    window.addEventListener("resize", () => this.isMobile(), true);
    this.setState({
      isTumblrBackgroundOpen: true,
    })
    document.documentElement.scrollTop = 0
    this.calculate()
    window.addEventListener('scroll', this.watchScroll)
    this.setVideoSources()
    
    if (window.innerWidth <= 480) {
      window.open(this.state.mobileSource)
    }

  }

  componentWillUnmount() {
    this.setState({
      isTumblrBackgroundOpen: false,
    })
    window.removeEventListener('scroll', this.watchScroll)
    window.removeEventListener('resize', () => this.isMobile(), true)

  }

  onVideoPlay() {
    this.setState({
      playing: true,
      needsInteraction: false,
    })
  }

  setVideoSources() {
    // Select randomly from the remaining video versions
    const cookie = Cookies.get('gen-videos-played')
    let videosPlayed = (cookie) ? cookie.split(',') : []
    if (videosPlayed.length === 3) videosPlayed = []
    if (videosPlayed.length === 3) Cookies.remove('gen-videos-played')

    const videosRemaining = (videosPlayed.length === 3) ?
      ['1', '2', '3'] :
      R.reject(n => R.contains(n, videosPlayed), ['1', '2', '3'])

    const videoToPlay = videosRemaining[Math.floor(Math.random() * videosRemaining.length)]
    Cookies.set('gen-videos-played', R.join(',', R.append(videoToPlay, videosPlayed)))

    // Select the source first by window size, then by the video to play
    let size = (window.outerWidth > 1024) ? 'hd'
      : (window.outerWidth > 720) ? 'large'
        : (window.outerWidth > 480) ? 'medium'
          : 'small'

    const sources = videos[size][videoToPlay - 1]
    this.setState({
      playing: false,
      sources,
    }, () => {
      this.video.load()
      this.playVideo()
    })
  }

  playVideo() {
    if (!this.video) return
    this.video.play().then(() => {
      this.setState({ playing: true })
    }).catch((err) => {
      this.setState({
        needsInteraction: true,
      })
    })
  }

  registerVideoRef(element) {
    this.video = element;
    this.playVideo()
  }

  watchScroll() {
    if (!this.mainContainer) return
    const scrollTop = pageYOffset || document.body.scrollTop
    if (scrollTop >= this.mainContainer.scrollHeight) {
      this.props.history.push('/')
    }
  }

  calculate() {
    clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => {
      const body = { document }
      const html = document.documentElement
      this.windowHeight = window.innerHeight || html.clientHeight || body.clientHeight
      this.documentHeight = this.mainContainer.scrollHeight
    }, 250)
  }

  render() {
    if (!this.state.sources) return null;
    const classNames = ['genevieve']
    if (this.state.complete) classNames.push('cartier--complete')
    if (this.state.needsInteraction) classNames.push('needsInteraction')
    const videoClassNames = ['videoFrame', 'videoFrame--full'];
    videoClassNames.push((this.state.playing) ? 'video--playing' : 'video--loading');

    return (
      <div>
        <section ref={(element) => { this.mainContainer = element }} className={cn(classNames)}>
          <button className="videoPlay" onClick={() => this.playVideo()}><span /></button>
          {
            this.state.isMobile ? (
              <div className={cn(videoClassNames)}>
                <img src="/images/logo-eye.png" alt="LuckyMe" className="loading-eye" />
                <video
                  poster={this.state.sources[2]}
                >
                  <source src={this.state.sources[0]} type="video/webm" />
                  <source src={this.state.sources[1]} type="video/mp4" />
                </video>
              </div>

            ) : (
                <div className={cn(videoClassNames)}>
                  <img src="/images/logo-eye.png" alt="LuckyMe" className="loading-eye" />
                  <video
                    ref={this.registerVideoRef}
                    poster={this.state.sources[2]}
                    onPlay={this.onVideoPlay}
                    src={this.state.sources[0]}
                  >
                    <source src={this.state.sources[0]} type="video/webm" />
                    <source src={this.state.sources[1]} type="video/mp4" />
                  </video>
                </div>

              )
          }

        </section>
        <Main emailLogo={this.props.data.allContentfulLuckymeLba.edges[0].node.meta.emailLogo.file.url}  {...this.props.data.allContentfulLuckymeLba.edges[0].node.content} tumblr={this.props.data.allTumblrAssets.edges} />

      </div>

    )
  }
}

Genevieve.propTypes = {
  // title: PropTypes.string
}

Genevieve.defaultProps = {
  // title: 'My Title'
}


export const query = graphql`
  query genevievePage {
    allContentfulLuckymeLba {
      edges {
        node {
          meta {
            emailLogo {
              file {
                url
              }
            }
          }
          content {
            merch {
              link 
              item {
                file {
                  url
                }
              }
            }
            videos {
              title
              id
              color
              videoSlug
              stripHover {
                file {
                  url
                }
              }
              stripStatic {
                file {
                  url
                }
              }
            }
            listen {
              title
              portrait {
                file {
                  url
                }
              }
              enabled
              itunes
              spotify
              download {
                file {
                  url
                }
              }
            }
          }
        }
      }
    }
    allTumblrAssets {
      edges {
        node {
          id
          summary
          timestamp
          type
          photos {
            original_size {
              url
              width
              height
            }
            alt_sizes {
              url
              width
              height
            }
            
          }
        }
      }
    }
  
  }
`

export default Genevieve



// WEBPACK FOOTER //
// ./src/pages/Genevieve.js